import { IconNames } from 'ui/theme';
import { MenuItem } from 'ui/components/Menu';

export const createActionBarOptions = (
  id: number | null,
  onShowReport: () => void
): MenuItem[] => [
  {
    icon: IconNames.FBOReportSmall,
    label: 'Show Report',
    onOptionClick: onShowReport,
    disabled: !id || id < 0,
  },
];
